import { PButtonPure } from '@porsche-design-system/components-react';
import { spacingStaticMedium } from '@porsche-design-system/components-react/styles';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import styled from 'styled-components';
import runtime from '../../../runtime';
import Copyright from '../../blocks/Copyright';

const Wrapper = styled.div({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    gap: spacingStaticMedium,
});

const MenuItems = styled.div({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: spacingStaticMedium,
});

export type UserNavigationItem = { name: string; href?: string; onClick?: () => void };

type Props = {
    userNavigation: Array<UserNavigationItem>;
};

const SideMenu = ({ userNavigation }: Props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const onNav = useCallback(
        (item: UserNavigationItem) => {
            if (item?.href) {
                navigate(item.href);
            }

            if (item?.onClick) {
                item?.onClick();
            }
        },
        [navigate]
    );

    return (
        <Wrapper>
            <MenuItems>
                {userNavigation.map(item => (
                    <PButtonPure
                        key={item.name}
                        active={item?.href ? location.pathname.includes(item.href) : false}
                        icon="none"
                        inert={undefined}
                        onClick={() => onNav(item)}
                        style={{ width: '100%' }}
                        type="button"
                    >
                        {item.name}
                    </PButtonPure>
                ))}
            </MenuItems>
            {runtime.organization && (
                <Copyright
                    align="left"
                    organizationLegalName={runtime.organization.legalName}
                    version={runtime.appVersion}
                    isTwoPart
                />
            )}
        </Wrapper>
    );
};

export default SideMenu;
